import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconItalyComponent = ({ ...rest }) => {
  return (
    <SvgIcon {...rest}>
      <svg
        fill="none"
        height="60"
        viewBox="0 0 80 60"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M54 0H72C76.4183 0 80 3.58172 80 8V52C80 56.4183 76.4183 60 72 60H54V0Z"
          fill="#CE2B37"
        />
        <path
          d="M0 8C0 3.58172 3.58172 0 8 0H26V60H8C3.58172 60 0 56.4183 0 52V8Z"
          fill="#009246"
        />
        <rect fill="#F0F0F0" height="60" width="28" x="26" />
      </svg>
    </SvgIcon>
  );
};

IconItalyComponent.displayName = 'IconItaly';

const IconItaly = memo(IconItalyComponent);

export default IconItaly;
